import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { fmtEuro, QUOTE_STATUSES } from "@/lib/api";

const field = "h-10 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm outline-none focus:border-emerald-500";
const label = "block text-xs font-medium uppercase tracking-wider text-slate-500";

export const QuoteSummary = ({ q, setQ, totals }) => (
  <div className="h-fit space-y-4 rounded-2xl border border-slate-200 bg-white p-5">
    <label className={label}>Stato</label>
    <Select value={q.status} onValueChange={(v) => setQ({ ...q, status: v })}>
      <SelectTrigger data-testid="quote-status-select" className="rounded-xl"><SelectValue /></SelectTrigger>
      <SelectContent>{QUOTE_STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
    </Select>
    <label className={label}>IVA</label>
    <Select value={String(q.vat_rate)} onValueChange={(v) => setQ({ ...q, vat_rate: Number(v) })}>
      <SelectTrigger data-testid="quote-vat-select" className="rounded-xl"><SelectValue /></SelectTrigger>
      <SelectContent><SelectItem value="10">10% (abitazioni)</SelectItem><SelectItem value="22">22% (aziende)</SelectItem></SelectContent>
    </Select>
    <label className={label}>Potenza (kWp)</label>
    <input data-testid="quote-kwp-input" type="number" min="0" step="0.1" className={field} value={q.kwp ?? ""} onChange={(e) => setQ({ ...q, kwp: e.target.value })} />
    <div className="space-y-2 border-t border-slate-100 pt-4 text-sm">
      <div className="flex justify-between"><span className="text-slate-500">Imponibile</span><span data-testid="quote-subtotal">{fmtEuro(totals.subtotal)}</span></div>
      <div className="flex justify-between"><span className="text-slate-500">IVA {q.vat_rate}%</span><span data-testid="quote-vat">{fmtEuro(totals.vat)}</span></div>
      <div className="flex justify-between text-lg font-semibold"><span>Totale</span><span data-testid="quote-total">{fmtEuro(totals.total)}</span></div>
    </div>
  </div>
);
